import * as o from "react";
import e from "../lib/IconBase.es.js";
import r from "../defs/Lightning.es.js";
const t = o.forwardRef((n, i) => /* @__PURE__ */ o.createElement(e, { ref: i, ...n, weights: r }));
t.displayName = "LightningIcon";
const c = t;
export {
  c as Lightning,
  t as LightningIcon
};
